import * as React from 'react'
import { observer } from 'mobx-react'
import { JobListViewModel } from './JobListViewModel'
import JobItem from './JobItem'
import JobListHeader from './JobListHeader'
import { Id } from 'types/definitions'
import { useScrollOffsetSpring } from 'hooks/spring-hooks'
import InfiniteScrollLoader from 'components/InfiniteScrollLoader'
import { Sandwich, SandwichBun, SandwichContent } from 'components/Sandwich'
import ContentLoading from 'components/ContentLoading'
import ErrorBlock from 'components/ErrorBlock'
import ScrollView from 'components/ScrollView'
import JobListEmpty from './JobListEmpty'

interface JobListProps {
  vm: JobListViewModel
}

export default observer(function JobList({ vm }: JobListProps) {
  const scrollRef = React.useRef<HTMLDivElement | null>(null)
  const scrollOffset = useScrollOffsetSpring(scrollRef)
  return (
    <Sandwich stretch>
      <SandwichBun>
        <JobListHeader vm={vm} scrollOffset={scrollOffset} />
      </SandwichBun>
      <SandwichContent>
        {vm.activate.match({
          pending: () => <ContentLoading />,
          rejected: (err: unknown) => <ErrorBlock tackOn="top" error={err} />,
          resolved: () => (
            <ScrollView ref={scrollRef}>
              {!vm.searcher.scroller.fetch.pending &&
                vm.jobs.length === 0 &&
                vm.searcher.scroller.isDone && <JobListEmpty vm={vm} />}
              {vm.jobs.map((jobItem) => (
                <JobItem vm={jobItem} key={Id.assert(jobItem.job.id)} />
              ))}
              <InfiniteScrollLoader scrollProvider={vm.searcher.scroller} />
            </ScrollView>
          ),
        })}
      </SandwichContent>
    </Sandwich>
  )
})
